import React, { useState } from 'react';

function makeTypeChecker (tabsRole) {
  return (element) => !!element.type && element.type.tabsRole === tabsRole;
}

const isTab = makeTypeChecker('Tab');
const isTabList = makeTypeChecker('TabList');
const isTabPanel = makeTypeChecker('TabPanel');

function getTabs (children) {
  const tabs = [];

  React.Children.forEach(children, (child) => {
    if (isTabList(child)) {
      React.Children.forEach(child.props.children, (child) => {
        if (isTab(child)) tabs.push(child.props.name);
      });
    }
  });

  return tabs;
}

/**
 * Uncontrolled Tabs component
 * @param {{
 *   className?: string,
 *   onSelect?: function,
 *   variant?: 'tabs'|'pills'
 * }} props
 * @return {JSX.Element}
 * @constructor
 */
const Tabs = (props) => {
  const {
    children,
    className,
    onSelect,
    variant = 'tabs',
  } = props;

  const [selectedTab, setSelectedTab] = useState();

  const tabs = getTabs(children);
  React.useEffect(() => {
    if (tabs.length > 0) {
      setSelectedTab(tabs[0]);
    }
  }, []);

  // React.useEffect(() => {
  //   if (tabs.length === 0) {
  //     setSelectedTab(null);
  //     return;
  //   }
  //
  //   if (selectedTab === null || (selectedTab && tabs.includes(selectedTab))) {
  //     return;
  //   }
  //
  //   if (defaultSelected === null) {
  //     return;
  //   }
  //
  //   setSelectedTab(defaultSelected && tabs.includes(defaultSelected) ? defaultTab : tabs[0]);
  // }, [selectedTab, defaultSelected, tabs]);

  const handleSelected = (tab, event) => {
    setSelectedTab(tab);

    if (onSelect) {
      onSelect(event);
    }
  };

  function getChildren () {
    return React.Children.map(children, (child) => {
      let result = child;

      if (isTabList(child)) {
        result = React.cloneElement(child, {
          children: React.Children.map(child.props.children, (tab) => {
            const props = {
              onSelect: handleSelected,
              selected: selectedTab === tab.props.name,
              variant,
            };
            return React.cloneElement(tab, props);
          }),
        });
      } else if (isTabPanel(child)) {
        const props = {
          selected: selectedTab === child.props.id,
        };
        result = React.cloneElement(child, props);
      }

      return result;
    });
  }

  return <div className={className}>
    {getChildren()}
  </div>;
};

export default Tabs;
